module.exports = __webpack_public_path__ + "img/folder-add.10c8d966.svg";